import React from "react";
import { Button } from "@carbon/react";
import { Launch, Play, Download } from "@carbon/icons-react";

const URL_RE = /^https?:\/\/\S+$/i;

export function isProbablyUrl(v) {
  if (v == null) return false;
  const s = String(v).trim();
  return URL_RE.test(s);
}

export function renderCellValue(value, colDesc, options = {}) {
  if (React.isValidElement(value)) return value;

  const str = value == null ? "" : String(value);
  const trimmed = str.trim();

  if (!trimmed) {
    return "";
  }

  const isStorageResource = Boolean(colDesc?.is_storage_resource);
  const isUrl = Boolean(colDesc?.is_url) || isProbablyUrl(trimmed);

  if (isStorageResource) {
    const handlePlay = async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (typeof options.onStorageResourcePlayClick === "function") {
        await options.onStorageResourcePlayClick({
          value: trimmed,
          colDesc,
        });
      }
    };

    const handleDownload = async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (typeof options.onStorageResourceDownloadClick === "function") {
        await options.onStorageResourceDownloadClick({
          value: trimmed,
          colDesc,
        });
      }
    };

    return (
      <>
        <Button
          kind="ghost"
          size="sm"
          hasIconOnly
          renderIcon={Play}
          iconDescription="Reproducir vídeo"
          tooltipPosition="top"
          onClick={handlePlay}
        />

        <Button
          kind="ghost"
          size="sm"
          hasIconOnly
          renderIcon={Download}
          iconDescription="Descargar recurso"
          tooltipPosition="top"
          onClick={handleDownload}
        />
      </>
    );
  }

  if (isUrl && isProbablyUrl(trimmed)) {
    const handleOpenUrl = (event) => {
      event.preventDefault();
      event.stopPropagation();

      window.open(trimmed, "_blank", "noopener,noreferrer");
    };

    return (
      <Button
        kind="ghost"
        size="sm"
        hasIconOnly
        renderIcon={Launch}
        iconDescription="Abrir enlace"
        tooltipPosition="top"
        onClick={handleOpenUrl}
      />
    );
  }

  return str;
}